import { useState } from 'react';
import './tags.css';

export default function Tags({ data, setData, name }) {
    const [tag, setTag] = useState('');

    function addTag() {
        if (!tag.trim()) {
            alert('Please enter a tag');
            return;
        }

        setData((prevState) => ({
            ...prevState,
            [name]: [...(prevState[name] || []), tag.trim()]
        }));

        setTag('');
    }

    function removeTag(text) {
        setData((prevState) => ({
            ...prevState,
            [name]: prevState[name].filter((t) => t !== text)
        }));
    }

    return (
        <div className='tagsDiv'>
            <h2 className='orgPackUpH2'>{name === 'excludedTags' ? 'Exclude Tags' : 'Tags'}</h2>

            <div className='itineraryInDiv tagOff'>
                <div className='itineraryInputDiv'>
                    <input
                        type='text'
                        value={tag}
                        onChange={(e) => setTag(e.target.value)}
                        placeholder={
                            name === 'excludedTags'
                                ? 'Enter and press Add to exclude'
                                : 'Enter and press Add to include'
                        }
                        className='nestedTagInput'
                        onKeyDown={(e) => e.key === 'Enter' && addTag()}
                    />
                    <button type='button' onClick={addTag} className='nestedTagOkBtn blueBtn'>
                        {name === 'excludedTags' ? 'Add Exclude' : 'Add Tag'}
                    </button>
                </div>
            </div>

            {data?.[name]?.length > 0 && (
                <div className='tagContainerOff'>
                    <div className='tagOutDiv'>
                        {data[name].map((text, index) => (
                            <div key={index} className='tagDiv'>
                                <p className='tagP'>{text}</p>
                                <button className='tagButton' onClick={() => removeTag(text)}>
                                    X
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
